import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { WEB_PACKAGES } from "@/data/pricing";

const ctaPath = (id) => `/preventivo-gratuito?pacchetto=${id}`;

export const PackageCard = ({ p, compact }) => {
  const hot = p.featured;
  const tint = { start: "bg-[#EAF4FF]", business: "bg-[#EEE8FF]", premium: "bg-[#E8F7F0]", "digital-partner": "bg-[#FFF0E6]" }[p.id] || "bg-[#F4EAFE]";
  const free = (p.setup || "").startsWith("Nessun");
  const list = compact && p.highlights ? p.highlights : p.features;
  return (
    <article data-testid={`pricing-package-${p.id}`}
      className={`lift relative flex flex-col rounded-3xl p-6 sm:p-7 ${tint} text-slate-700 ${hot ? "border-2 border-blue-600 shadow-[0_30px_60px_-25px_rgba(39,83,245,0.55)] lg:-translate-y-3" : "border border-white shadow-[0_18px_40px_-28px_rgba(15,23,42,0.35)]"}`}>
      {hot && <span className="absolute -top-3 left-6 rounded-full bg-blue-600 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white shadow-lg">{p.badge || "Consigliato"}</span>}
      <p className={`text-xs font-semibold uppercase tracking-[0.16em] text-blue-700`}>{p.name}</p>
      <h3 className={`mt-2 font-display text-xl font-bold leading-snug !text-slate-900`}>{p.headline || p.tagline}</h3>
      <div className={`mt-5 border-y py-5 border-slate-900/10`}>
        <p className={`font-display text-4xl font-extrabold tracking-tight !text-slate-900`}>{free ? p.monthly : p.setup}</p>
        <p className={`mt-1 text-sm text-slate-600`}>
          {free ? p.setup : <>{p.setup.startsWith("Da") ? "+ " : "una tantum + "}<strong className="text-slate-900">{p.monthly}</strong></>} · IVA esclusa
        </p>
      </div>
      <ul className={`mt-5 space-y-2.5 text-sm ${compact ? "" : "flex-1"}`}>
        {(list || []).filter(Boolean).map((f) => <li key={f} className="flex gap-2.5"><Check className={`mt-0.5 h-4 w-4 shrink-0 text-blue-600`} /><span>{f}</span></li>)}
      </ul>
      {!compact && p.note && <p className={`mt-5 text-xs leading-relaxed text-slate-600`}>{p.note}</p>}
      <div className={compact ? "mt-auto pt-6" : "pt-6"}>
        <Link to={ctaPath(p.id)} data-testid={`pricing-package-${p.id}-cta`} className={`w-full ${hot ? "btn-primary" : "btn border border-blue-600 bg-white/70 text-blue-700 hover:bg-blue-600 hover:text-white"}`}>
          Voglio {p.name} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </article>
  );
};

export default function PricingCards({ ids, compact }) {
  const list = ids ? WEB_PACKAGES.filter((p) => ids.includes(p.id)) : WEB_PACKAGES;
  const cols = list.length >= 4 ? "lg:grid-cols-4" : list.length === 3 ? "lg:grid-cols-3" : "lg:grid-cols-2";
  return (
    <div className={`snap-row !gap-4 pt-3 sm:grid sm:grid-cols-2 sm:overflow-visible ${cols}`}>
      {list.map((p) => <div key={p.id} className="flex w-[84%] sm:w-auto [&>article]:w-full"><PackageCard p={p} compact={compact} /></div>)}
    </div>
  );
}
